<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="300"
    offset-y
    rounded
    transition="slide-y-reverse-transition"
    top
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-show="prod_list.length"
        fab
        dark
        fixed
        bottom
        right
        v-bind="attrs"
        color="#1141ce"
        v-on="on"
      >
        <v-badge
          :content="prod_list.length"
          :value="prod_list.length"
          color="red"
          overlap
        >
          <v-icon> mdi-message-image </v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card
      v-if="prod_list.length"
      width="100%"
      height="100%"
      class="mx-auto"
      outlined
      color="#fafafa"
    >
      <v-list-item tow-line>
        <v-list-item-content class="pb-1">
          <v-list-item-title class="headline mb-1">
            Messanger
          </v-list-item-title>
          <v-list-item-subtitle>
            Send products to this client
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-btn
          disabled
          absolute
          bottom
          fab
          right
          class="mr-6 mb-7"
          @click="send()"
        >
          <v-icon>mdi-email-send </v-icon>
        </v-btn>
      </v-list-item>
      <v-container>
        <v-row dense no-gutters>
          <v-col cols="12" sm="12">
            <v-textarea
              v-model="text"
              class="ml-3 mr-3"
              label="write message to client"
              color="teal"
              rows="2"
            />
          </v-col>
          <v-col cols="12" sm="12">
            <v-card
              color="#fafafa"
              width="100%"
              height="100%"
              elevation="0"
              class="scroll2 mx-auto"
            >
              <v-row dense>
                <v-col
                  v-for="prod in prod_list"
                  :key="prod.product_id"
                  class="d-flex child-flex"
                  cols="3"
                  sm="4"
                >
                  <v-img
                    :src="prod.picture_url"
                    gradient="to right top, rgba(255, 255, 255, 0.24), rgba(21, 22, 25, 0.35)"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <template v-slot>
                      <v-btn dark icon @click="remove_prod(prod)">
                        <v-icon>mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        />
                      </v-row>
                    </template>
                  </v-img>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      more: false,
      fab: false,
      go_top: false,
      menu: false,
      text: null,
    };
  },
  computed: {
    prod_list: {
      get: function () {
        const prod = this.$store.state.prod_to_sent.item;
        return prod;
      },
    },
  },
  methods: {
    remove_prod(prod) {
      for (let i = 0; i < this.prod_list.length; i++) {
        const element = this.prod_list[i];
        if (element.product_id === prod.product_id) {
          this.$store.state.prod_to_sent.item.splice(i, 1);
          this.$store.state.prod_to_sent.ids.splice(i, 1);
        }
      }
    },
    select_user(value) {
      this.$socket.emit("SelectUser", value.guid, (data) => {
        if (typeof data === "string") {
          console.error(data);
        } else {
          console.log("user selected :", value.id, value.guid);
        }
      });
    },
    send() {
      this.select_user(this.$store.state.user.infos.user);
      if (this.$store.state.prod_to_sent.ids.length) {
        const res = [];
        this.$store.state.prod_to_sent.item.forEach((element) => {
          res.push(element);
        });
        const client_obj = {
          message: {
            message: "look",
            carousel: {
              mode: "explore",
              type: "products",
              values: res,
            },
          },
          user: this.$store.state.user.infos.user.guid,
          conversation_id: "7146",
          look: true,
        };
        this.$socket.emit("ChatUser", client_obj, (data) => {
          if (typeof data === "string") {
            console.error(data);
          } else {
            this.$store.state.prod_to_sent.ids = [];
            this.$store.state.prod_to_sent.item = [];
            client_obj.user = this.$store.state.user.infos.user.id;
            client_obj.message = JSON.stringify(client_obj.message);
          }
        });
      }
      if (this.text) {
        const obj = {
          message: this.text,
          user: this.$store.state.user.infos.user.guid,
          conversation_id: "7146",
          look: false,
        };
        this.$socket.emit("ChatUser", obj, (data) => {
          if (typeof data === "string") {
            console.error(data);
          } else {
            this.text = "";
            obj.user = this.$store.state.user.infos.user.id;
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.scroll2 {
  overflow: hidden scroll !important;
  scroll-behavior: smooth;
  max-height: 250px !important;
}

.scroll2::-webkit-scrollbar {
  width: 7px;
  height: 15%; /* width of the entire scrollbar */
}
.scroll2::-webkit-scrollbar-track {
  background: #80808038;
  border-radius: 20px; /* color of the tracking area */
}
.scroll2::-webkit-scrollbar-thumb {
  background-color: #1a4dcd; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 1px solid grey; /* creates padding around scroll thumb */
}
</style>
